import React from "react";
import {
  SubmitButton,
  ButtonVariantOption,
  ButtonColorOption,
} from "@/components/Button";
import { useApiClient } from "@/hooks/useApiClient";
import { getAttachedFileNameFromHeader } from "@/utils/utils";
import fileDownload from "js-file-download";
import { toast } from "react-toastify";
import DownloadIcon from "@mui/icons-material/Download";
import { SizingWrapperStyle } from "@/components/Wrapper";
import { Typography } from "@mui/material";
interface OutputMenuProps {
  disabled: boolean;
  requestId: number;
}

export default function OutputMenu({
  disabled,
  requestId,
}: OutputMenuProps): React.ReactElement {
  const { apiClient } = useApiClient();
  const onDownloadFile = (
    requestId: number,
    fallBackName: string,
    cancelLoading: () => void
  ): void => {
    apiClient
      .get(`/all-matters-analyze/download-file/${requestId}`, {
        responseType: "blob",
      })
      .then((res) => {
        const filename = getAttachedFileNameFromHeader(res, fallBackName);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        fileDownload(res.data, filename);
        cancelLoading();
      })
      .catch((e) => {
        console.error(e);
        toast.error("ファイルのダウンロードに失敗しました");
        cancelLoading();
      });
  };

  return (
    <div>
      <SubmitButton
        size={SizingWrapperStyle.SMALL}
        disabled={disabled}
        variant={ButtonVariantOption.Outlined}
        color={ButtonColorOption.Primary}
        label="エクセル出力"
        startIcon={<DownloadIcon />}
        timeout={120000} // 120秒のタイムアウト
        loadingIndicator={
          <Typography variant="button">ダウンロード中...</Typography>
        }
        onClick={(_, cancelLoading) => {
          onDownloadFile(
            requestId,
            `全部事項解析結果_${requestId}.xlsx`,
            cancelLoading
          );
        }}
        onTimeout={() => {
          toast.error(
            "ダウンロードがタイムアウトしました。しばらく経ってから再度お試しください。"
          );
        }}
      />
    </div>
  );
}
